import { Campaign } from "@vviinn/user-managment-client-ts";

import { CampaignFilterType } from "./types";

// Sorting is applied once the campaign and boosting lists are combined (see
// combineSorted in routes/campaign/list.tsx) so the two domains interleave correctly
// instead of each being sorted independently and then concatenated.
export const selectCampaigns = (
  campaigns: Campaign[],
  search: string,
  activeOnly: boolean,
  filters?: CampaignFilterType[],
) => {
  let formattedCampaigns: Campaign[] = [];
  const lowercaseSearch = search.toLowerCase();
  for (let campaign of campaigns) {
    formattedCampaigns.push({
      ...campaign,
      name: campaign.name ?? "",
    });
  }

  if (search) {
    formattedCampaigns = formattedCampaigns.filter((campaign) =>
      campaign?.name?.toLowerCase().includes(lowercaseSearch),
    );
  }
  if (activeOnly) {
    formattedCampaigns = formattedCampaigns.filter(
      (campaign) => campaign.active,
    );
  }
  if (filters && filters.length > 0) {
    formattedCampaigns = formattedCampaigns.filter((campaign) =>
      filters.includes(campaign.type),
    );
  }
  return formattedCampaigns;
};
